import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', solar: '#f4c542', grid: '#3a8dde', load: '#ff5a7f' };
const fmt0 = v => (v != null && !isNaN(v) ? (typeof v === 'number' ? v.toFixed(2) : v) : '-');
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

export default function AircondTable({ data }) {
  const { t } = useTranslation();

  const columns = [
    { title: 'sn', dataIndex: 'sn', key: 'sn', render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span>, width: 130 },
    { title: t('cloud.deviceNo'), dataIndex: 'global_no', key: 'global_no', render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span>, width: 110 },
    { title: t('cloud.name'), dataIndex: 'name', key: 'name', render: (n, r) => n || r.global_no || '-', width: 130 },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag>, width: 80 },
    { title: t('cloud.runStatus'), dataIndex: 'run_status', key: 'run_status', render: v => v != null ? <Tag>{v}</Tag> : '-', width: 90 },
    { title: t('cloud.mode'), dataIndex: 'mode', key: 'mode', render: v => v || '-', width: 90 },
    { title: t('cloud.temperatureC'), dataIndex: 'temperature_c', key: 'temperature_c', render: v => <span style={{ color: COLORS.solar }}>{fmt0(v)}</span>, width: 100 },
    { title: t('cloud.setTemperatureC'), dataIndex: 'set_temperature_c', key: 'set_temperature_c', render: fmt0, width: 110 },
    { title: t('cloud.humidity'), dataIndex: 'humidity_percent', key: 'humidity_percent', render: v => <span style={{ color: COLORS.grid }}>{fmt0(v)}</span>, width: 100 },
    { title: t('cloud.inletTemperatureC'), dataIndex: 'inlet_temperature_c', key: 'inlet_temperature_c', render: fmt0, width: 120 },
    { title: t('cloud.outletTemperatureC'), dataIndex: 'outlet_temperature_c', key: 'outlet_temperature_c', render: fmt0, width: 120 },
    { title: t('cloud.pumpStatus'), dataIndex: 'pump_status', key: 'pump_status', render: v => v != null ? <Tag>{v}</Tag> : '-', width: 100 },
    { title: t('cloud.fanStatus'), dataIndex: 'fan_status', key: 'fan_status', render: v => v != null ? <Tag>{v}</Tag> : '-', width: 100 },
    { title: t('cloud.faultCode'), dataIndex: 'fault_code', key: 'fault_code', render: v => v != null ? <Tag color="red">{v}</Tag> : '-', width: 80 },
    { title: t('cloud.alarmCode'), dataIndex: 'alarm_code', key: 'alarm_code', render: v => v != null ? <Tag color="orange">{v}</Tag> : '-', width: 80 },
    { title: t('cloud.recordTime'), dataIndex: 'recorded_at', key: 'recorded_at', render: fmtTime, width: 160 },
  ];

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.primary, fontSize: 14, fontWeight: 600, marginBottom: 8, borderLeft: '3px solid #ff5a7f', paddingLeft: 8 }}>
        {t('cloud.telemetryAircond')} {data.length} {t('cloud.telemetryRecords')}
      </div>
      <Table columns={columns} dataSource={data} rowKey="id" size="small" pagination={{ pageSize: 5, showSizeChanger: false }} style={{ background: 'transparent' }} scroll={{ x: 2000 }} tableLayout="fixed" />
    </div>
  );
}
